import { useEffect, useState } from 'react';
import { track } from '@generated/hooks/useTrack';
import { ShoppingBag, Newspaper, Megaphone } from 'lucide-react';
import { Shop } from '@generated/components/Shop';
import { MugOrder } from '@generated/components/MugOrder';
import { Subscribe } from '@generated/components/Subscribe';
import { ClassifiedForm } from '@generated/components/ClassifiedForm';

type Tab = 'shop' | 'subscribe' | 'classifieds';
const TABS: { id: Tab; label: string; icon: typeof ShoppingBag }[] = [
  { id: 'classifieds', label: 'Classified Ads', icon: Megaphone },
  { id: 'shop', label: 'Star-Revue Merch', icon: ShoppingBag },
  { id: 'subscribe', label: 'Subscriptions', icon: Newspaper },
];

export function Personal() {
  const [tab, setTab] = useState<Tab>('classifieds');
  useEffect(() => { track(tab === "shop" ? "view_merch" : tab === "subscribe" ? "view_subscribe" : "view_classifieds", true); }, [tab]);
  const go = (id: Tab, scroll: boolean) => { setTab(id); if (scroll) window.scrollTo({ top: 0, behavior: 'smooth' }); };
  return (
    <div>
      <nav aria-label="Classifieds, Souvenirs &amp; Subscriptions" className="mb-8 flex gap-1 overflow-x-auto border-b border-border">
        {TABS.map(({ id, label, icon: Icon }) => (
          <button key={id} onClick={() => go(id, false)} className={`inline-flex min-h-11 shrink-0 items-center gap-2 border-b-2 px-4 text-sm font-semibold ${tab === id ? 'border-primary text-foreground' : 'border-transparent text-muted-foreground hover:text-foreground'}`}>
            <Icon className="h-4 w-4" />{label}
          </button>
        ))}
      </nav>
      {tab === 'shop' && <><Shop /><MugOrder /></>}
      {tab === 'subscribe' && <Subscribe />}
      {tab === 'classifieds' && <ClassifiedForm />}
      <nav aria-label="More in Classifieds, Souvenirs &amp; Subscriptions" className="mt-12 border-t-4 border-double border-foreground pt-5">
        <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-primary">Also in Classifieds, Souvenirs &amp; Subscriptions</div>
        <div className="mt-3 grid gap-2 sm:grid-cols-2">
          {TABS.filter((t) => t.id !== tab).map(({ id, label, icon: Icon }) => (
            <button key={id} onClick={() => go(id, true)} className="flex min-h-14 items-center gap-3 border border-foreground bg-[hsl(var(--brand-yellow))] px-4 text-left font-semibold text-foreground hover:opacity-90">
              <Icon className="h-5 w-5 shrink-0" />{label}
            </button>
          ))}
        </div>
      </nav>
    </div>
  );
}
